import styled from '@mui/system/styled';

const Img = styled('img')({
  height: 28,
  width: 110,
});

export default Img;
